import { t } from 'i18next';
function OrderStatusCell(props:any) {

    const label =t('syncflow:lb_order_supplier_status_' + props.statusCode);


   if(props.statusCode=='N' || props.statusCode=='D' || props.statusCode=='WP')
            return <span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{props.label}</span>
        if(props.statusCode=='R')
            return <span className="text-danger fw-bold text-hover-danger d-block fs-6 ">{props.label}</span>
        if(props.statusCode=='A' && props.isAllApproved)
            return <span className="text-success fw-bold text-hover-success d-block fs-6 ">{props.label}</span>
        if(props.statusCode=='A' && !props.isAllApproved)
            return <span className="text-warning fw-bold text-hover-warning d-block fs-6 ">{props.label}</span>
}

export default OrderStatusCell;